import {ResizableBox, ResizableBoxProps} from 'react-resizable';

type Props = {
    children: React.ReactNode;
    disabled?: boolean
} & ResizableBoxProps;

export const ResizableBoxWrapper: React.FC<Props> = ({children, disabled, ...resizableBoxProps}: Props) => (
    <ResizableBox
        className='tw-h-full'
        {...resizableBoxProps}
        {...(disabled && {axis: 'none'})}
    >
        {children}
    </ResizableBox>
);
